import React, { useEffect, useState } from "react";
import AddGroup from "./AddGroup.js";
import "./groupdetail.css";
import { FaTrash, FaEdit, FaPlus, FaChevronDown, FaChevronUp } from "react-icons/fa";
import axios from "axios";
import { APIURL, TZ } from "../../../../Global.js";
import { useAlert } from 'react-alert';
import AddNew from "./AddNew.js";
const GroupShow = () => {
    const [addGroup, setAddGroup] = useState(false);
    const [add, setAdd] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedSection, setExpandedSection] = useState({
        panels: true,
        tests: true
    });
    const alert = useAlert();

    // Sample data with the new structure
    const groups = [
        {
            id: 1,
            name: "Basic Health Package",
            description:"Primary checkup",
            panels: [{ id: 56, name: "panel 1", sample: "blood" }, { id: 5, name: "panel 1", sample: "urine" }],
            tests: [{ id: 32, name: "test 1", sample: "blood" }, { id: 12, name: "test 1", sample: "blood" }]
        },
        {
            id: 2,
            name: "Urine Analysis",            
            description:"Primary checkup",
            panels: [{ id: 34, name: "panel 1", sample: "serum" }, { id: 4, name: "panel 1", sample: "sputum" }, { id: 5, name: "panel 1", sample: "blood" }],
            tests: [{ id: 3, sample: "blood", name: "test 1" }]
        },
        {
            id: 3,
            name: "Diabetes Check",
            description:"Primary checkup",
            panels: [{ id: 9, sample: "blood", name: "panel 1" }],
            tests: [{ id: 6, name: "test 1", sample: "blood" }, { id: 41, name: "test 1", sample: "blood" }, { id: 44, name: "test 1", sample: "blood" }]
        },
    ];

    const filteredGroups = groups.filter(group =>
        group.name.toLowerCase().includes(searchTerm.toLowerCase())
    );



    const toggleSection = (section) => {
        setExpandedSection(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const handleDeleteGroup = async (groupId) => {
        try {
            await axios.delete(`${APIURL}/api/v1/groups/${groupId}/`);
            setRefresh(!refresh);
            alert.success("Group deleted successfully");
            if (selectedGroup?.id === groupId) {
                setSelectedGroup(null);
            }
        } catch (error) {
            alert.error("Failed to delete group");
        }
    };

    const handleEditGroup = (group) => {
        setSelectedGroup(group);
        setEditMode(true);
        setAddGroup(true);
    };

    const handleAddItems = (type) => {
        setAdd(type)
        console.log(`Add ${type} to group ${selectedGroup.id}`);
    };

    const handleRemoveItem = (type, itemId) => {
        console.log(`Remove ${type} ${itemId} from group`);
    };

    return (
        <div className="group-show-container">
            <div className="group-header">
                <h2>Test Groups Management</h2>
                <button
                    className="primary-btn"
                    onClick={() => {
                        setSelectedGroup(null);
                        setEditMode(false);
                        setAddGroup(true);
                    }}
                >
                    <FaPlus /> Add Group
                </button>
            </div>

            <div className="group-layout">
                {/* Left Column - Group List */}
                <div className="group-list-container">
                    <div className="search-filter">
                        <input
                            type="text"
                            placeholder="Search groups..."
                            className="search-input"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="group-items">
                        {filteredGroups.map(group => (
                            <div
                                key={group.id}
                                className={`group-card ${selectedGroup?.id === group.id ? 'active' : ''}`}
                                onClick={() => setSelectedGroup(group)}
                            >
                                <div className="group-card-header">
                                    <h4>{group.name}</h4>
                                    <div className="group-actions">
                                        <FaEdit
                                            className="list-edit-icon"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleEditGroup(group);
                                            }}
                                        />
                                        <FaTrash
                                            className="action-icon delete"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteGroup(group.id);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="group-meta">
                                    <div className="count-badges">
                                        <span>{group.panels.length} Panels</span>
                                        <span>{group.tests.length} Tests</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="group-details-container">
                    {selectedGroup ? (
                        <>
                            <div className="details-header">
                                <h3>{selectedGroup.name}</h3>
                            </div>

                            <div className="details-sections">
                                <div className="details-section">
                                    <div
                                        className="section-header clickable"
                                        onClick={() => toggleSection('panels')}
                                    >
                                        <h4>
                                            Panels
                                            <span className="count-badge">
                                                {selectedGroup.panels.length}
                                            </span>
                                        </h4>
                                        <div className="section-actions">
                                            <button
                                                className="secondary-btn small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAddItems('panel');
                                                }}
                                            >
                                                <FaPlus /> Add Panel
                                            </button>
                                            {expandedSection.panels ? <FaChevronUp /> : <FaChevronDown />}
                                        </div>
                                    </div>

                                    {expandedSection.panels && (
                                        selectedGroup.panels.length > 0 ? (
                                            <ul className="items-list">
                                                {selectedGroup.panels.map((panel) => {
                                                    return (
                                                        <li key={panel.id}>
                                                            <div className="item-info">
                                                                <span className="item-name">
                                                                    {panel.name}
                                                                </span>
                                                                <span className="item-sample">
                                                                    {panel.sample}
                                                                </span>
                                                            </div>
                                                            <FaTrash
                                                                className="list-action-icon"
                                                                onClick={() => handleRemoveItem('panel', panel.id)}
                                                            />
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        ) : (
                                            <p className="empty-message">No panels in this group</p>
                                        )
                                    )}
                                </div>

                                <div className="details-section">
                                    <div
                                        className="section-header clickable"
                                        onClick={() => toggleSection('tests')}
                                    >
                                        <h4>
                                            Tests
                                            <span className="count-badge">
                                                {selectedGroup.tests.length}
                                            </span>
                                        </h4>
                                        <div className="section-actions">
                                            <button
                                                className="secondary-btn small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAddItems('test');
                                                }}
                                            >
                                                <FaPlus /> Add Test
                                            </button>
                                            {expandedSection.tests ? <FaChevronUp /> : <FaChevronDown />}
                                        </div>
                                    </div>

                                    {expandedSection.tests && (
                                        selectedGroup.tests.length > 0 ? (
                                            <ul className="items-list">
                                                {selectedGroup.tests.map((test) => {
                                                    return (
                                                        <li key={test.id}>
                                                            <div className="item-info">
                                                                <span className="item-name">
                                                                    {test.name}
                                                                </span>
                                                                <span className="item-sample">
                                                                    {test.sample}
                                                                </span>
                                                            </div>
                                                            <FaTrash
                                                                className="list-action-icon"
                                                                onClick={() => handleRemoveItem('test', test.id)}
                                                            />
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        ) : (
                                            <p className="empty-message">No tests in this group</p>
                                        )
                                    )}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="empty-state">
                            <h3>Select a group to view details</h3>
                            <p>Or create a new group to get started</p>
                        </div>
                    )}
                </div>
            </div>

            {addGroup && (
                <AddGroup                
                    from='lab'
                    groupData={editMode ? selectedGroup : null}
                    handleSuccess={() => {
                        setRefresh(!refresh);
                        setAddGroup(false);
                        setEditMode(false);
                    }}
                    onClose={() => {
                        setAddGroup(false);
                        setEditMode(false);
                    }}
                />
            )}
            {add && (
                <AddNew
                    group={selectedGroup}
                    type={add}
                    handleSuccess={() => {
                        setRefresh(!refresh);
                        setAddGroup(false);
                        setEditMode(false);
                    }}
                    onClose={() => {
                        setAdd(false);
                    }}
                />
            )}
        </div>
    );
};

export default GroupShow;